/**
 * generates Unique ID using Math by picking
 * - random number
 * - timestamp
 * - precised to @param length
 * @param length define length for uniq string
 * @return string
 */
export const uniqueId = (length = 16) =>
  parseInt(
    Math.ceil(Math.random() * Date.now())
      .toPrecision(length)
      .toString()
      .replace('.', ''),
  );

/**
 * Generate a random size-character hexadecimal string
 * - random number
 * - precised to @param size
 * @param size define length for hexadecimal string
 * @return string
 */
//
export const generateRandomHex = (size: number) =>
  Array(size)
    .fill(0)
    .map(() => Math.floor(Math.random() * 16).toString(16))
    .join('');

/**
 * Generate a random size-character hexadecimal string
 * @param length
 * @returns
 */
export function generateRequestId(length: number) {
  const hexChars = '0123456789abcdef';
  let result = '';

  for (let i = 0; i < length; i++) {
    result += hexChars[Math.floor(Math.random() * 16)];
  }

  return result;
}
